export const SearchFilterLabels = {
	categoryIds: 'Category',
	folderIds: 'Folder',
	uploadedByIds: 'Uploaded by',
	mimeTypes: 'File type',
	freeText: 'Freetext',
	fileName: 'Filename',
	name: 'Title',
	mediaIds: 'ID',
	objectIds: 'Object ID'
}